import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipDeclaration, TPatchClipDeclaration } from '../types';

type TPatchClipDeclarationProps = {
  id: string;
  body: TPatchClipDeclaration;
};
export async function patchClipDeclaration({
  id,
  body,
}: TPatchClipDeclarationProps): Promise<TClipDeclaration> {
  return mediaManagerClient.patch(`/api/v1/clip_declarations/${id}`, emptyStringValues(body));
}

type MutationFn = typeof patchClipDeclaration;

type TUsePatchClipDeclarationParams = {
  config?: MutationConfig<MutationFn>;
  invalidateClipQueries?: boolean;
};

export function usePatchClipDeclarations({
  config = {},
  invalidateClipQueries = false,
}: TUsePatchClipDeclarationParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchClipDeclaration,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar la declaración del corte'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La declaración del corte se ha actualizado correctamente'));
      if (invalidateClipQueries) {
        queryClient.invalidateQueries({ queryKey: ['clips'] });
      }
    },
  });
}
